import { IonContent, IonPage, useIonPicker, useIonToast } from '@ionic/react'
import { checkbox, warning } from 'ionicons/icons'
import { useContext, useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { VALIDATE_STATUS } from '../../../common'
import { CustomSpacer, TextStyle, StyleIonHeader, FooterButtons } from '../../../components'
import { StyleIonInput } from '../../../components/atoms/input/StyleIonInput'
import { StoresContext } from '../../../provider/StoreProvider'

export const SettingAccount: React.FC<RouteComponentProps> = ({ history }) => {
  const { myStore } = useContext(StoresContext)
  const [bankOwner, setBankOwner] = useState<string | undefined>()
  const [bankName, setBankName] = useState<string | undefined>()
  const [account, setAccount] = useState<string | undefined>()
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS>(VALIDATE_STATUS.INPUT)
  const [presentToast] = useIonToast()
  const [present] = useIonPicker()
  const openPicker = async () => {
    present({
      columns: [
        {
          name: 'bankList',
          options: [
            {
              text: 'NH농협',
              value: 'NH농협',
            },
            {
              text: '신한은행',
              value: '신한은행',
            },
            {
              text: '우리은행',
              value: '우리은행',
            },
            {
              text: '국민은행',
              value: '국민은행',
            },
          ],
        },
      ],
      buttons: [
        {
          text: 'Done',
          handler: (value) => {
            setBankName(`${value.bankList.value}`)
          },
        },
      ],
    })
  }

  const onInputName = (bankOwner: string | number) => {
    setBankOwner(String(bankOwner))
  }

  const onInputAccount = (account: string | number) => {
    setAccount(String(account))
  }

  const validate = () => {
    if (bankOwner != undefined && bankName != undefined && account != undefined) {
      if (bankOwner?.length > 0 && bankName?.length > 0 && account?.length > 0) {
        setValidateStatus(VALIDATE_STATUS.OKAY)
      } else {
        setValidateStatus(VALIDATE_STATUS.INPUT)
      }
    }
  }

  const onModifyUserInfo = async () => {
    const modifyResult = await myStore.modifyUserInfo({
      withdrawalAccount: {
        bankOwner: bankOwner as string,
        bankName: bankName as string,
        account: account as string,
        isActive: true,
      },
    })
    if (modifyResult) {
      await presentToast({
        message: '정보 수정이 정상적으로 완료되었습니다.',
        duration: 3000,
        position: 'top',
        color: 'primary',
        icon: checkbox,
      })
      await history.push('/myPage/setting')
    } else {
      await presentToast({
        message: '정보 수정에 실패했습니다. 잠시 후 다시 시도해주세요!',
        duration: 3000,
        position: 'top',
        color: 'danger',
        icon: warning,
      })
    }
  }

  useEffect(() => {
    validate()
  }, [bankOwner, bankName, account])

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'예치금 출금계좌 변경'} href={'/myPage/setting'} />
      <IonContent>
        <SectionContainer>
          <TextStyle type={'r_13'}>예금주</TextStyle>
          <CustomSpacer spacing="8px" />
          <StyleIonInput
            type={'text'}
            inputmode={'text'}
            inputType={'INPUT'}
            placeholder={'이름을 입력해주세요'}
            onInput={onInputName}
          />
          <CustomSpacer spacing="24px" />
          <TextStyle type={'r_13'}>은행</TextStyle>
          <CustomSpacer spacing="8px" />
          <ReadonlyContainer onClick={openPicker}>
            <TextStyle type={'r_15'} color={bankName ? 'primary_dark' : 'gray400'}>
              {bankName ?? '은행명을 선택해주세요.'}
            </TextStyle>
          </ReadonlyContainer>
          <CustomSpacer spacing="24px" />
          <TextStyle type={'r_13'}>계좌번호</TextStyle>
          <CustomSpacer spacing="8px" />
          <StyleIonInput
            type={'text'}
            inputmode={'text'}
            inputType={'INPUT'}
            placeholder={'계좌번호를 입력해주세요'}
            onInput={onInputAccount}
          />
        </SectionContainer>
      </IonContent>
      <FooterButtons
        button={{
          color: 'dark',
          text: validateStatus !== VALIDATE_STATUS.OKAY ? '내용을 입력해주세요.' : '변경하기',
          disabled: validateStatus !== VALIDATE_STATUS.OKAY ? true : false,
          onClick: () => onModifyUserInfo(),
        }}
      />
    </IonPage>
  )
}

const SectionContainer = styled.div`
  padding: 24px 20px;
`

const ReadonlyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15.5px;
  @media (prefers-color-scheme: light) {
    border: solid 1px #e9e9e9 !important;
  }
  @media (prefers-color-scheme: dark) {
    border: solid 1px #30363a !important;
  }
  border-radius: 8px;
  min-height: 56px;
`
